<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :rules="rules" :model="dioForm" label-width="140px" class="password-form">
            <el-form-item :label="$t('integration.old_password')" prop="oldPwd">
                <el-input v-model.trim="dioForm.oldPwd" style="width: 250px" :type="confirmNewSecretFlag == false ? 'password' : 'text'" auto-complete="on">
                    <i slot="suffix" :class="confirmNewSecretFlag == false ? 'iconfont icon-biyan' : 'el-icon-view'" @click="changeIconState('confirmNewSecretFlag')"></i>
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('integration.new_password')" prop="newPwd">
                <el-input v-model.trim="dioForm.newPwd" style="width: 250px" :type="confirmNewSecretFlag1 == false ? 'password' : 'text'" auto-complete="on">
                    <i slot="suffix" :class="confirmNewSecretFlag1 == false ? 'iconfont icon-biyan' : 'el-icon-view'" @click="changeIconState('confirmNewSecretFlag1')"></i>
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('integration.confirm_password')" prop="surePwd">
                <el-input v-model.trim="dioForm.surePwd" style="width: 250px" :type="confirmNewSecretFlag2 == false ? 'password' : 'text'" auto-complete="on">
                    <i slot="suffix" :class="confirmNewSecretFlag2 == false ? 'iconfont icon-biyan' : 'el-icon-view'" @click="changeIconState('confirmNewSecretFlag2')"></i>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { minePassword } from '@/api/modules/material.js';
import { userLogout } from '@/api/modules/indexPage.js';
export default {
    props: ['isShowPass', 'title'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShowPass;
            },
            set: function(val) {
                this.$emit('update:isShowPass', val); //可以优化成model  或者minx
            }
        },
        rules() {
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error($t('integration.please_input_a_password')));
                } else {
                    if (this.dioForm.surePwd !== '') {
                        this.$refs.form.validateField('surePwd');
                    }
                    callback();
                }
            };
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error($t('integration.please_enter_the_password_again')));
                } else if (value !== this.dioForm.newPwd) {
                    callback(new Error($t('integration.the_two_passwords_are_inconsistent_e')));
                } else {
                    callback();
                }
            };

            return {
                oldPwd: [
                    { required: true, message: $t('integration.old_password_cannot_be_empty'), trigger: 'blur' },
                    { trigger: 'blur', pattern: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,30}$/, message: this.$t('integration.pwd_tips1') }
                ],
                newPwd: [
                    { required: true, message: $t('integration.the_new_password_cannot_be_empty'), trigger: 'blur' },
                    { trigger: 'blur', pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,30}$/, message: $t('accountRedesign.err_password_policy') },
                    { validator: validatePass, trigger: 'blur' }
                ],
                surePwd: [
                    { required: true, message: $t('integration.confirmation_cannot_be_empty'), trigger: 'blur' },
                    { trigger: 'blur', pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,30}$/, message: $t('accountRedesign.err_password_policy') },
                    { validator: validatePass2, trigger: 'blur' }
                ]
            };
        }
    },
    data() {
        return {
            dioForm: {
                oldPwd: '',
                newPwd: '',
                surePwd: ''
            },
            confirmNewSecretFlag: false,
            confirmNewSecretFlag1: false,
            confirmNewSecretFlag2: false,
            passwordType: 'password'
        };
    },
    methods: {
        changeIconState(str) {
            if (str === 'confirmNewSecretFlag') {
                this.confirmNewSecretFlag = !this.confirmNewSecretFlag;
            } else if (str === 'confirmNewSecretFlag1') {
                this.confirmNewSecretFlag1 = !this.confirmNewSecretFlag1;
            } else {
                this.confirmNewSecretFlag2 = !this.confirmNewSecretFlag2;
            }
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return;

            minePassword(this.dioForm).then(({ result, state }) => {
                if (result === 406) {
                    this.$message.error($t('integration.userInformation_not_found'));
                } else if (result === 407) {
                    this.$message.error($t('integration.the_old_password_is_incorrect'));
                } else if (result === 408) {
                    this.$message.error($t('accountRedesign.err_password_policy'));
                } else if (result === 200) {
                    this.$message.success($t('integration.modification_succeeded_c__please_login_again'));
                    userLogout().then(() => {
                        this.$router.push('/login');
                    });
                } else {
                    this.$message.error(state.msg);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.password-form {
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep .el-form-item {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    width: 250px;
  }

  ::v-deep .el-form-item__label {
    white-space: nowrap;
  }

  /* 错误提示撑开高度但限制宽度与输入框一致，避免布局错乱 */
  ::v-deep .el-form-item__error {
    position: static;
    display: block;
    width: 250px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.5;
    padding-top: 2px;
  }
}
</style>
